import useUserData from "../../../hooks/user/useUserData";
import {useCallback, useEffect, useMemo, useRef, useState} from "react";

// const imageUploadHandler = (blobInfo, success, failure, progress) => {
//     const blobToBase64 = function (blob, callback) {
//         const reader = new FileReader()
//         reader.onload = function () {
//             const dataUrl = reader.result
//             const base64 = dataUrl.split(',')[1]
//             callback(base64)
//         }
//         reader.readAsDataURL(blob)
//     }
//     blobToBase64(blobInfo.blob(), (data) => success('data:image/png;base64, ' + data))
// }
import {imageOptions} from "./imageOptions";

const textStyles = '.printable-wrapper { border: 2px solid black; padding: 2.5pt; max-width: 600pt; margin: auto; font-family: \'ATAndreSans\', serif; } .printable { font-size: 10pt; max-width: 595pt; color: var(--badge-text-default-color); } .printable-split { display: grid; grid-template-columns: 1fr 1fr; height: 420pt; overflow: hidden; } .printable-split .printable-info:first-child { border-right: 1px dashed var(--badge-border-color); } .printable-info { display: flex; flex-direction: column; justify-content: space-between; } .printable-info-header { display: grid; grid-template-columns: repeat(2, 1fr); grid-gap: 10pt; padding: 10pt; } .printable-info-header h2, .printable-info-header h3 { margin-top: 0; } .printable-info-header h3 { font-size: 1.2em; margin-bottom: 0; } .printable-info-header h2 { font-size: 1.5em; } .printable-info-header > div:nth-child(1) { text-align: center; border-right: 1px dashed var(--badge-color); line-height: 1; } .printable-info-header > div:nth-child(2) { text-align: right; line-height: 1; } .printable-info-header > div:nth-child(2) h3 { font-size: 2em; color: var(--badge-color); } .printable-info-credentials { text-align: center; padding: 1em; } .printable-info-credentials h2, .printable-info-credentials h3 { margin-top: 0; } .printable-info-role { line-height: 1; padding: 1em; text-align: center; font-size: 1.5em; font-weight: 900; color: var(--badge-text-color); background: var(--badge-color); border-bottom: 1px dashed var(--badge-border-color); } .printable-text { padding: 5pt 10pt; font-size: 0.85em; color: var(--badge-text-default-color); } .printable-text h3 { font-size: 0.9em; margin-top: 0.25em; margin-bottom: 0.25em; background: var(--badge-color); color: var(--badge-text-color); padding: 0.15em 0.5em; font-weight: bold; } .printable-text ul { margin: 0; padding: 0 0 0 1.25em; } .printable-text p { margin-top: 0; margin-bottom: 0.25em; } .printable-text table { width: 100% !important; } .printable-text td { width: initial !important; height: initial !important; padding: 0 2px; } /*# sourceMappingURL=printable.css.map */'

const tableSelectionStyles = `td[data-mce-selected="1"],
th[data-mce-selected="1"] {
  background-color: rgba(25, 118, 210, 0.20) !important;
  outline: 1px solid #1976d2 !important;
  outline-offset: -1px !important;
}`;

export const useEditorParameters = (props, initType = 1) => {
    const editorRef = useRef(null)
    const {
        field,
        form: {
            handleChange,
            handleBlur,
            initialValues,
            values
        },
        onEditorClick = () => {}
    } = props

    const [elValue, setElValue] = useState('')
    const {language} = useUserData()

    useEffect(() => {
        setElValue(field.value)
    }, [field.value])


    const defaultRootStyles = values.colors && values.colors.length ? `:root { --badge-color: ${values?.colors[0]}; --badge-text-color: ${values?.colors[1]}; --badge-text-default-color: ${values?.colors[2]}; --badge-border-color: lightgray; }` : ''
    const setRootStyle = useCallback(() => {
        if (editorRef.current) {
            let root = editorRef.current.contentWindow?.document?.documentElement;
            if (root && values.colors && values.colors.length) {
                root.style.setProperty('--badge-color', values?.colors[0]);
                root.style.setProperty('--badge-text-color', values?.colors[1]);
                root.style.setProperty('--badge-text-default-color', values?.colors[2]);
            }
        }
    }, [values.colors])

    useEffect(() => {
        setRootStyle()
    }, [setRootStyle])


    const init1 = useMemo(() => ({
        ...imageOptions,
        language: language,
        body_class: 'printable-text',
        content_style: tableSelectionStyles,
        height: '100%',
        menubar: false,
        font_formats:
            'Arial=Arial,Helvetica,sans-serif;' +
            'Verdana=Verdana,Geneva,sans-serif;' +
            'Tahoma=Tahoma,Arial,Helvetica,sans-serif;' +
            'Times New Roman="Times New Roman",Times,serif;' +
            'Courier New="Courier New",Courier,monospace;',
        paste_as_text: true,
        quickbars_image_toolbar: 'alignleft aligncenter alignright',
        table_toolbar: 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
        plugins: ['advlist lists table link autolink fullscreen image paste print code directionality visualchars  hr preview'],
        toolbar: 'formatselect | fontselect | fontsizeselect | bold italic underline strikethrough | forecolor backcolor | removeformat | align lineheight |  link image table | bullist numlist | outdent indent |  ltr rtl | hr | subscript superscript | fullscreen code preview print visualchars | undo redo',
        visualchars_default_state: true,
        // images_upload_handler: imageUploadHandler,
    }), [language])

    const init2 = useMemo(() => ({
        ...imageOptions,
        skin: false,
        language: language,
        body_class: 'printable-text',
        content_style: [textStyles, defaultRootStyles, tableSelectionStyles].join('\n'),
        height: '100%',
        menubar: false,
        font_formats:
            'Arial=Arial,Helvetica,sans-serif;' +
            'Verdana=Verdana,Geneva,sans-serif;' +
            'Tahoma=Tahoma,Arial,Helvetica,sans-serif;' +
            'Times New Roman="Times New Roman",Times,serif;' +
            'Courier New="Courier New",Courier,monospace;',
        paste_as_text: true,
        quickbars_image_toolbar: 'alignleft aligncenter alignright',
        table_toolbar: 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
        plugins: ['advlist lists table link autolink fullscreen image paste print code directionality visualchars hr preview'],
        toolbar:
            'formatselect | fontselect | fontsizeselect | bold italic underline strikethrough | forecolor backcolor | removeformat | align lineheight |  link image table | bullist numlist | outdent indent |  ltr rtl | hr | subscript superscript | fullscreen code preview print visualchars | undo redo',
        // images_upload_handler: imageUploadHandler,
    }), [defaultRootStyles, language])
 
    return {
        ...field,
        init: initType === 2 ? init2 : init1,
        onInit: (evt, editor) => {
            editorRef.current = editor
            // setElValue(field.value)
        },
        initialValue: initialValues[field.name],
        onEditorChange: (value) => {
            setElValue(value)
        },
        textareaName: field.name,
        onClick: (e) => {onEditorClick(e, editorRef)},
        onBlur: (e) => {
            if (handleChange) {
                handleChange({target: {name: field.name, value: elValue}})
            }
            if (handleBlur) {
                handleBlur(e)
            }
        },
        value: elValue,
    }
}
